const state = {
  newTableItemPopupVisible: false,
  confirmationPopupVisible: false
}

const getters = {
  newTableItemPopupVisible: (state) => {
    return state.newTableItemPopupVisible
  },
  confirmationPopupVisible: (state) => {
    return state.confirmationPopupVisible
  }
}

const mutations = {
  setNewTableItemPopupVisible(state, newValue) {
    state.newTableItemPopupVisible = newValue
  },
  setConfirmationPopupVisible(state, newValue) {
    state.confirmationPopupVisible = newValue
  }
}

const actions = {
  showNewTableItemPopup({commit}) {
    commit('setNewTableItemPopupVisible', true)
  },
  hideNewTableItemPopup({commit}) {
    commit('setNewTableItemPopupVisible', false)
  },
  showConfirmationPupup({ commit }) {
    commit('setConfirmationPopupVisible', true)
  },
  
}

export default {
  state,
  getters,
  mutations,
  actions
}